<div class="activeadmin-container" appDevTag="shared/components/activeadmin">
  <!-- Botão para ativar/desativar modo dev (Roda dentada) -->
  <button
    *ngIf="globalService.loggedUserClass?.Admin"
    mat-icon-button
    type="button"
    (click)="globalService.AtiveDevMode()"
    [matTooltip]="appVersionTooltip"
    matTooltipPosition="below"
    matTooltipShowDelay="250"
    aria-label="Versão da aplicação"
    class="dev-mode-toggle"
    [class.dev-mode-active]="globalService.EnableDevelopermode"
  >
    <mat-icon class="admin-gear-icon">settings</mat-icon>
    <!-- Badge ADMIN visível quando modo está ativo -->
    <span *ngIf="globalService.EnableDevelopermode" class="admin-badge">ADMIN</span>
  </button>

  <!-- Container FERRAMENTAS EXTRAS (Só visível se Admin + Modo Dev) -->
  <ng-container *ngIf="globalService.loggedUserClass?.Admin && globalService.EnableDevelopermode">
    <!-- Menu de Ferramentas de Desenvolvimento (3 Pontos) -->
    <button mat-icon-button [matMenuTriggerFor]="devMenu" matTooltip="Ferramentas de Desenvolvimento">
      <mat-icon class="dev-menu-icon">more_vert</mat-icon>
    </button>

    <!-- Botão de Feedback In-App (AGORA A SEGUIR AOS 3 PONTOS) -->
    <button
      mat-icon-button
      (click)="openFeedbackDialog()"
      [matTooltip]="'ADMIN_FEEDBACK.FAB_TOOLTIP' | translate"
      matTooltipPosition="below"
      class="feedback-inline-btn"
    >
      <mat-icon class="feedback-inline-icon">chat_bubble_outline</mat-icon>
      <span
        *ngIf="pendingFeedbackCount > 0"
        class="feedback-pending-badge"
        [matTooltip]="pendingFeedbackCount + ' tarefa(s) por concluir'"
      >
        {{ pendingFeedbackCount }}
      </span>
    </button>

    <mat-menu #devMenu="matMenu">
      <!-- Gerir Layout Homepage -->
      <button mat-menu-item (click)="openHomepageLayoutManagement()">
        <mat-icon style="color: #1c1464">dashboard_customize</mat-icon>
        <span>Gerir Layout da Homepage</span>
      </button>

      <!-- Parametrização de Produtos e Sub-produtos -->
      <button mat-menu-item (click)="openProductsQuickManagement()">
        <mat-icon style="color: #00a896">tune</mat-icon>
        <span>Parametrização de Produtos & Sub-Produtos</span>
      </button>

      <mat-divider></mat-divider>

      <!-- Toggle Tags Visuais -->
      <button mat-menu-item (click)="globalService.toggleDevTags()">
        <mat-icon [style.color]="globalService.ShowDevTags ? '#4caf50' : '#757575'">
          {{ globalService.ShowDevTags ? 'visibility' : 'visibility_off' }}
        </mat-icon>
        <span>{{ globalService.ShowDevTags ? 'Ocultar Tags' : 'Mostrar Tags' }}</span>
      </button>

      <mat-divider></mat-divider>

      <!-- Gestão de Feedback & Melhorias -->
      <button mat-menu-item [routerLink]="'/sitemanagement/feedback'">
        <mat-icon style="color: #38b2ac">rate_review</mat-icon>
        <span>Gestão de Feedback & Melhorias</span>
      </button>
    </mat-menu>
  </ng-container>
</div>
